import { compose, overSome } from 'lodash/fp';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';

import { DistributorContextValue, Route, withDistributorContext } from '@mews-distributor/common';
import { createAction } from '@mews/framework';

import { fpViewWrapper } from '../../../../enhancers/viewWrapper';
import { DETAILS_LOADED } from '../../../../middlewares/gtmActions';
import {
    getAvailabilityBlockIdFromQuery,
    getCurrentRoute,
    isCurrencyChangeInProgress,
} from '../../../../modules/app/selectors';
import { hasSpecialRequestsFieldFeature } from '../../../../modules/configuration/selectors';
import {
    areAnyExchangeRatesFetching,
    hasAnyExchangeRatesFailed,
} from '../../../../modules/entities/exchangeRates/selectors';
import { isAnyPricingFetching } from '../../../../modules/pricing/selectors';
import { getSelectedHotelId } from '../../../../modules/resourceOrder/selectors';
import { isAnyServicePricingFetching } from '../../../../modules/servicePricing';
import { isValidAvailabilityBlock } from '../../../../selectors/views/availabilityBlocks';
import { hasSelectedEnterprisePciProxyStorage } from '../../../../selectors/views/selectedEnterprisePaymentConfiguration';
import { ApplicationState } from '../../../../types';
import { isBookerEnabled, isCheckoutFetching, isCheckoutPreparing } from '../../data/selectors';
import {
    isImmediatelySettledTotalAmountPositiveWithPreauthorizations,
    shouldDisplayPaymentCardForm,
} from '../../data/viewSelectors';
import {
    checkoutDismiss,
    checkoutTryAgain,
    finishBooking,
    getCheckoutStatus,
    hasCheckoutFailed,
    hasCheckoutPreparationFailed,
    hasCustomerErrors,
    isCheckoutInProgress,
} from '../../slices';
import { getSelectedEnterpriseSmsConsent } from '../../../../selectors/views/selectedEnterprise/selectedEnterprise';

const isRouteNotCheckout = createSelector(getCurrentRoute, (route) => route !== Route.Checkout);

const isFetching = overSome([
    isCheckoutFetching,
    isCheckoutPreparing,
    isAnyPricingFetching,
    isAnyServicePricingFetching,
    areAnyExchangeRatesFetching,
    isCurrencyChangeInProgress,
    isRouteNotCheckout,
]);

const hasFailed = overSome([hasCheckoutFailed, hasCheckoutPreparationFailed, hasAnyExchangeRatesFailed]);

const keepView = createSelector(
    hasSelectedEnterprisePciProxyStorage,
    isCheckoutInProgress,
    (hasPciProxy, checkoutInProgress) => hasPciProxy && checkoutInProgress
);

const onLoaded = () => (dispatch: $TSFixMe) => {
    dispatch(createAction(DETAILS_LOADED));
};

export const inject = compose(
    withDistributorContext,
    connect(
        createStructuredSelector<ApplicationState, $TSFixMe, $TSFixMe>({
            enterpriseId: getSelectedHotelId,
            isFetching,
            hasError: hasCustomerErrors,
            hasFailed,
            isImmediatelySettledTotalAmountPositive: isImmediatelySettledTotalAmountPositiveWithPreauthorizations,
            keepView,
            hasPaymentCardForm: shouldDisplayPaymentCardForm,
            hasSpecialRequestsFieldFeature,
            isBookerEnabled,
            hasPciProxy: hasSelectedEnterprisePciProxyStorage,
            loader: getCheckoutStatus,
            isBookerOptionDisabled: (state: ApplicationState, { appClockService }: DistributorContextValue) => {
                const nowUtc = appClockService.getAppNowUtc();
                const availabilityBlockId = getAvailabilityBlockIdFromQuery(state);
                // @ts-expect-error $TSFixMeError: Type 'string | undefined' is not assignable to type 'string'.
                return isValidAvailabilityBlock(state, { availabilityBlockId, nowUtc });
            },
            showSmsConsent: (state: ApplicationState) => {
                return getSelectedEnterpriseSmsConsent(state, {});
            },
        }),
        {
            onLoaded,
            onFinishBookingClick: finishBooking,
        }
    ),
    fpViewWrapper({
        error: {
            onTryAgain: checkoutTryAgain,
            onDismiss: checkoutDismiss,
        },
    })
);
